export var defaultColor = '#15F5BA';
export var defaultSelectionWrapperClassName = 'bg-lightgreen relative select-none';
export var defaultMinSelectionLength = 10;
